import React from 'react'

import styled from 'styled-components'

import { Icon, IconEnum, IconSizeEnum } from '@atoms/images/Icon'
import { Paragraph } from '@atoms/index'
import { ResponsivePXValue, theme } from '@client/components/Theme'

export interface IconSelectButtonProps {
  selected: boolean
  label: string
  icon: IconEnum
  onClick?: () => void
  className?: string
  iconColor?: string
  labelColor?: string
  children?: React.ReactNode
  style?: React.CSSProperties
  disabled?: boolean
}

const IconSelectButtonStyled = styled.button<{ selected: boolean, disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: border 0.2s, background 0.2s, color 0.2s;
  outline: none;
  border: 1.5px solid ${props => props.selected ? props.theme.colors.oranges.coral : props.theme.colors.whites.silver};
  background: ${props => props.selected ? props.theme.colors.oranges.coral : props.theme.colors.whites.pureWhite};
  color: ${props => props.selected ? props.theme.colors.whites.pureWhite : props.theme.colors.greys.mineshaft};
  box-shadow: ${props => props.selected ? '0 2px 8px rgba(255, 102, 0, 0.08)' : 'none'};
  ${ResponsivePXValue('padding', '16px 12px 10px 12px')};
  ${ResponsivePXValue('margin-right', '24px')};
  ${ResponsivePXValue('margin-bottom', '12px')};
  ${ResponsivePXValue('max-width', '90px')};
  ${ResponsivePXValue('max-height', '90px')};
  ${ResponsivePXValue('width', '90px')};
  ${ResponsivePXValue('height', '90px')};
  svg, img { ${ResponsivePXValue('margin-bottom', '8px')}; }
`

export const IconSelectButton: React.FC<IconSelectButtonProps> = ({
  selected,
  label,
  icon,
  onClick,
  className,
  iconColor,
  labelColor,
  children,
  style,
  disabled = false,
}) => (
  <IconSelectButtonStyled
    type="button"
    className={className || ''}
    style={style}
    selected={selected}
    disabled={disabled}
    onClick={onClick}
  >
    <Icon icon={icon} size={IconSizeEnum.SMALL} color={iconColor || (selected ? theme.colors.whites.pureWhite : theme.colors.greys.mineshaft)} />
    <Paragraph variant='p3' align='center' bold color={labelColor || (selected ? theme.colors.whites.pureWhite : theme.colors.greys.mineshaft)}>{label}</Paragraph>
    {children}
  </IconSelectButtonStyled>
)
